const route = {
	path: 'accounting-rules/new',
	name: 'accounting-rules-new',
	meta: {
		title: 'Nueva Regla Contable',
	},
	component: () => import('@/pages/accounting-rules/page-accounting-rule-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-rules-new.js